import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export const BinsAbove = ({ binsAbove }: { binsAbove: number }) => {
  const { t } = useTranslation();

  return (
    <Stack
      position="absolute"
      left="50%"
      top="100%"
      sx={{ transform: "translateX(-50%)", mt: "6px" }}
      alignItems="center"
    >
      <Typography
        color="white"
        fontSize="1.4rem"
        fontWeight={500}
        lineHeight="1"
      >
        {binsAbove}
      </Typography>
      <Typography
        color="white"
        fontSize=".9rem"
        fontWeight={500}
        whiteSpace="nowrap"
      >
        {t("bins down")}
      </Typography>
    </Stack>
  );
};
